'use client';

import { NavigationMenu } from '@base-ui/react/navigation-menu';
import { type ReactNode } from 'react';

import type { PrimaryNavigationItem } from '../../../../types';
import { NavigationItemLabel } from './navigation-item-label';
import { NavigationItemTrigger } from './navigation-item-trigger';

type NavigationItemProps = {
    children?: ReactNode;
    item: PrimaryNavigationItem;
    onKeyboardClose: () => void;
};

export function NavigationItem({ children, item, onKeyboardClose }: NavigationItemProps) {
    if (item.kind === 'link') {
        return (
            <NavigationMenu.Item value={item.id} className="desktop-menu__item">
                <NavigationItemLabel
                    emphasis={item.emphasis}
                    href={item.href}
                    openInNewTab={item.openInNewTab}
                    title={item.title}
                />
            </NavigationMenu.Item>
        );
    }

    return (
        <NavigationMenu.Item value={item.id} className="desktop-menu__item">
            <NavigationMenu.Trigger
                nativeButton={false}
                render={(props, state) => (
                    <NavigationItemTrigger
                        item={item}
                        onKeyboardClose={onKeyboardClose}
                        triggerProps={props}
                        triggerState={state}
                    />
                )}
            />
            {children}
        </NavigationMenu.Item>
    );
}
